import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$country/$language/$')({
  beforeLoad: () => {
    throw redirect({
      from: '/$country/$language/$',
      to: '/$country/$language/navigator',
    })
  },
})
